var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page2Point"},[_c('div',{ref:"point",staticClass:"point"})])
}
var staticRenderFns = []

export { render, staticRenderFns }